import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { OrganizationProvider } from "./contexts/OrganizationContext";
import { Toaster } from "@/components/ui/sonner";
import "./index.css";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <OrganizationProvider>
      <AuthProvider>
          <App />
          <Toaster
            position="top-right"
            richColors
            closeButton
            expand
            visibleToasts={5}
            gap={8}
            duration={5000}
          />
      </AuthProvider>
    </OrganizationProvider>
  </React.StrictMode>,
);

